import axios from 'axios'
import { baseUrl, mscfUrl, rootUrl, baseImgPath, UPLOADURL } from '@/config/env'
import { getStorage, setStorage } from '@/utils/myUtils'
import store from '@/store'
import { getQueryString } from '../utils/myUtils'

axios.defaults.timeout = 1200 * 1000
/**
 * 登陆
 * */
export let login = data => _axios(data.url, data.data, data.callback)
/**
 * 企业信息模块 get获取详情、update更新、add新增
 *  *informationIndexModule:企业信息
 *  packageList:企业套餐列表
 * */
export let informationIndexModule = {
  get: data => _axios('enterprise/detail', {}, data.success),
  update: data => _axios('enterprise/update', data.data, data.success, true),
  add: data => _axios('enterprise/add', data.data, data.success, true),
  packageList: data =>
    _axios('enterprise_package/list', data.data, data.success)
}
/**
 * 企业套餐模块
 * check:检查当前套餐
 * save:保存选择的套餐
 * **/
export let enterpriseRulesModule = {
  check: data => _axios('enterprise_rules/check', {}, data.success),
  save: data => _axios('enterprise_rules/save', data.data, data.success, true)
}

/** 统一下单模块**/
export let commonOrderModule = {
  common_order: data =>
    _axios('common_order/unifiedorder', data.data, data.success, true),
  detail: data => _axios('member_order/detail', data.data, data.success)
}
/**
 * 账户信息
 * get：获取账户信息
 * update：更新账户信息
 * messageList:消息列表
 * */
export let informationInfo = {
  get: data => _axios('common_member/detail', {}, data.success),
  update: data => _axios('member/update', data.data, data.success, true),
  messageList: data => _axios('member_notice/list', data.data, data.success)
}
/***
 * 部门模块
 */
export let departmentModule = {
  list: ({data, success, loading = true}) =>
    _axios('enterprise_department/list', data, success),
  detail: data =>
    _axios('enterprise_department/detail', data.data, data.success),
  add: data => _axios('enterprise_department/add', data.data, data.success),
  update: data =>
    _axios('enterprise_department/update', data.data, data.success),
  delete: data =>
    _axios('enterprise_department/delete', data.data, data.success)
}

/** 员工管理
 * list:员工列表 data:{is_resibnation:是否在职 0否1是}
 * detail：员工详情
 * editStaff:新增和修改员工  新增url:enterprise_employee/add;  修改url:enterprise_employee/update
 * leave:员工离职
 * delete:员工删除
 *
 * contractList:合同列表
 * contractDetail:合同详情
 * contractEdit:合同新增和修改 enterprise_employee/add，enterprise_employee/update
 *
 * employeeDecrease 员工离职减员
 * employeeDecreaseDetail 员工离职减员获取详情
 * */
export let staffModule = {
  list: data =>
    _axios('enterprise_employee_relation/list', data.data, data.success),
  detail: data =>
    _axios(
      'enterprise_employee_relation/detail',
      data.data,
      data.success,
      true
    ),
  editStaff: data => _axios(data.url, data.data, data.success, true),
  leave: data =>
    _axios(
      'enterprise_employee_relation/delete',
      data.data,
      data.success,
      true
    ),
  delete: data =>
    _axios('enterprise_employee/delete', data.data, data.success, true),
  contractList: data =>
    _axios('employee_contract/list', data.data, data.success),
  contractDetail: data =>
    _axios('employee_contract/detail', data.data, data.success),
  contractDelete: data =>
    _axios('employee_contract/delete', data.data, data.success, true),
  contractEdit: data => _axios(data.url, data.data, data.success, true),
  employeeDecrease: data =>
    _axios('enterprise_employee/decrease', data.data, data.success, true),
  employeeDecreaseDetail: data =>
    _axios('enterprise_employee/decrease_detail', data.data, data.success),
  // 导出员工
  exportStaff: data =>
    _axios('ExportExecel/staff_export', data.data, data.success, true),
  // 导出合同
  exportContract: data =>
    _axios('ExportExecel/employee_contract', data.data, data.success, true),
  // 多查少补列表
  employeeBalanceMonthList: data =>
    _axios('employee_balance_month/list', data.data, data.success, true),
  // 新增多查少补
  employeeBalanceMonthAdd: data =>
    _axios('employee_balance_month/compute', data.data, data.success, true),
  // 删除多查少补
  employeeBalanceMonthDel: data =>
    _axios('employee_balance_month/delete', data.data, data.success, true),
  // 重新入职
  resumeIncrease: data =>
    _axios('enterprise_employee/resume_increase', data.data, data.success, true)
}

/**
 * 社保、公积金管理
 * personalList:参保人员 社保："employee_insurance/list"，公积金：employee_fund/list
 * programmeAreaList:参保方案城市列表
 * programmeList：参保方案列表
 * employeeAdd:增员接口  社保增员：employee_insurance/increase，公积金增员:employee_fund/increase
 * employeeDetail:增员详情  社保增员详情：employee_insurance/detail   公积金增员详情 employee_fund/detail
 * payBack:员工补缴  目前在账单员工社保列表点击
 *
 * computeDetails:公积金社保计算器
 * basicRelation:险种关系列表
 *
 * monthList：缴费记录    社保记录：employee_insurance_month/list
 * monthDetail：缴费记录详情    社保记录：employee_insurance_month/detail
 * insuranceExport： 社保导出
 * fundExport 公积金导出
 * */

export let insuranceModule = {
  personalList: data => _axios(data.url, data.data, data.success),
  programmeAreaList: data =>
    _axios('basic_programme_area/list', {}, data.success),
  programmeList: data =>
    _axios('basic_programme/list', data.data, data.success),
  employeeAdd: data => _axios(data.url, data.data, data.success, true),
  employeeDetail: data => _axios(data.url, data.data, data.success, true),
  payBack: data =>
    _axios('paybackAction/payback', data.data, data.success, true),

  computeDetails: data =>
    _axios('basic_programme/computeDetails', data.data, data.success),
  basicRelation: data =>
    _axios('basic_programme_insurance/list', {}, data.success),

  monthList: data => _axios(data.url, data.data, data.success),
  monthDetail: data => _axios(data.url, data.data, data.success),
  insuranceExport: data =>
    _axios('employee_export/insurance_export', data.data, data.success),
  fundExport: data =>
    _axios('employee_export/fund_export', data.data, data.success)
}

/**
 *
 * 福利待遇模块
 * list:列表
 * detail：详情
 * edit：新增和修改
 * delete：删除
 * applySchedule:审核进度列表
 * applyScheduleDetail:审核进度详情
 * applyGrant:待遇发放详情
 * */
export let employeeApplyModule = {

  list: data => _axios('employee_apply/list', data.data, data.success),
  detail: data => _axios('employee_apply/detail', data.data, data.success),
  payDetail: data => _axios('employee_apply_pay/detail', data.data, data.success),
  payReceivedDetail: data => _axios('employee_apply_received/detail', data.data, data.success),
  edit: data => _axios(data.url, data.data, data.success, true),
  delete: data =>
    _axios('employee_apply/delete', data.data, data.success, true),
  applySchedule: data =>
    _axios('employee_apply_schedule/list', data.data, data.success),
  applyScheduleDetail: data =>
    _axios('employee_apply_schedule/detail', data.data, data.success),
  applyGrant: data =>
    _axios('employee_apply_grant/detail', data.data, data.success)
}

/**
 * 薪酬待遇模块
 * templateList：薪资组列表（模板）
 * templateAllList：所有公开薪资组列表（模板）
 * templateUpdate：薪资组修改
 * templateAdd：薪资组新增
 * templateDelete：薪资组删除
 * templateCopy：薪资组复制
 *
 * templateDetailsList:薪资组薪资项列表
 * templateDetailsUpdate:薪资组薪资项更新
 * templateDetailsAdd:薪资组薪资项新增
 * templateDetailsDelete:薪资组薪资项删除
 * templateDetailsBase:薪资组薪资项基础项
 *
 * salaryList:工资管理列表
 * salaryDetail:工资管理详情
 * salaryAddStaff:工资管理增加员工
 * salaryChooseStaffList:工资管理选中的员工列表
 * salaryChooseStaffSave:工资管理选中的员工保存数据
 * salaryAdd:工资管理新增
 * salaryUpdate:工资管理修改
 * salaryList:工资管理列表
 * salaryListDelete:工资管理模板删除
 * salaryListCopy:工资管理模板复制
 * salaryListStaffDelete:工资管理员工删除
 * exportExecel:工资模板导出
 * exportWages:工资管理导出

 * */
export let salaryModule = {
  templateList: data =>
    _axios('enterprise_staff_wages_template/list', data.data, data.success),
  templateAllList: data =>
    _axios('enterprise_staff_wages_template/public', data.data, data.success),
  templateUpdate: data =>
    _axios(
      'enterprise_staff_wages_template/update',
      data.data,
      data.success,
      true
    ),
  templateAdd: data =>
    _axios(
      'enterprise_staff_wages_template/add',
      data.data,
      data.success,
      true
    ),
  templateDelete: data =>
    _axios(
      'enterprise_staff_wages_template/delete',
      data.data,
      data.success,
      true
    ),
  templateCopy: data =>
    _axios(
      'enterprise_staff_wages_template/copy',
      data.data,
      data.success,
      true
    ),

  templateDetailsList: data =>
    _axios(
      'enterprise_staff_wages_template_details/list',
      data.data,
      data.success
    ),
  templateDetailsUpdate: data =>
    _axios(
      'enterprise_staff_wages_template_details/update',
      data.data,
      data.success
    ),
  templateDetailsAdd: data =>
    _axios(
      'enterprise_staff_wages_template_details/add',
      data.data,
      data.success
    ),
  templateDetailsDelete: data =>
    _axios(
      'enterprise_staff_wages_template_details/delete',
      data.data,
      data.success
    ),
  templateDetailsBase: data =>
    _axios(
      'enterprise_basic_wage_items/list',
      { pageSize: 100, pageIndex: 1 },
      data.success
    ),

  salaryAdd: data =>
    _axios('enterprise_staff_wages/chooseTemplate', data.data, data.success),
  salaryUpdate: data =>
    _axios(
      'enterprise_staff_wages_template_monthly/update',
      data.data,
      data.success
    ),
  salaryDetail: data =>
    _axios(
      'enterprise_staff_wages_template_monthly/detail',
      data.data,
      data.success
    ),
  salaryAddStaff: data =>
    _axios('enterprise_staff_wages/chooseStaff', data.data, data.success),
  salaryChooseStaffList: data =>
    _axios('enterprise_staff_wages/chooseStaffList', data.data, data.success),
  salaryChooseStaffSave: data =>
    _axios('enterprise_staff_wages/save', data.data, data.success),
  salaryList: data =>
    _axios(
      'enterprise_staff_wages_template_monthly/list',
      data.data,
      data.success
    ),
  salaryListAudit: data =>
    _axios(
      'enterprise_staff_wages_template_monthly/audit',
      data.data,
      data.success
    ),
  salaryListDelete: data =>
    _axios(
      'enterprise_staff_wages_template_monthly/delete',
      data.data,
      data.success
    ),
  salaryListStaffDelete: data =>
    _axios('staff_wages_template_relation/delete', data.data, data.success),
  salaryListCopy: data =>
    _axios('enterprise_staff_wages/copy', data.data, data.success),
  exportExecel: data =>
    _axios('ExportExecel/staff_wage_template', data.data, data.success, true),
  exportWages: data =>
    _axios('ExportExecel/export_wages', data.data, data.success, true)
}
/**
 * 账单模块
 * employeeList:员工参保列表
 * employeeCostList:员工费用列表
 * employeeWagesList:员工工资列表
 * enterpriseCostList:企业费用列表-所有月份
 * enterpriseCostDetail:企业费用详情-当前月份
 * enterpriseMonthInsured:生成本月参保数据
 * enterpriseMonthCost :生成本月账单数据
 * enterpriseMonthCost:生成本月账单数据
 * costOrder:创建支付订单
 * staffIncreaseDecrease:确认增减员操作
 * exportBills:账单导出
 * exportBillsGroups:账单导出-按单位部门岗位
 * enterpriseCostUpdateOtherCosts:企业费用-修改其他费用
 * **/

export let billsModule = {
  employeeList: data =>
    _axios('enterprise_employee_insured/list', data.data, data.success),
  employeeCostList: data =>
    _axios('enterprise_cost_month_list/list', data.data, data.success),
  employeeWagesList: data =>
    _axios('enterprise_employee_wages/list', data.data, data.success),
  enterpriseCostList: data =>
    _axios('enterprise_cost_month/list', data.data, data.success),
  enterpriseCostListDelete: data =>
    _axios('enterprise_cost_month/delete', data.data, data.success),
  enterpriseCostDetail: data =>
    _axios('enterprise_cost_month/detail', data.data, data.success),
  enterpriseMonthInsured: data =>
    _axios('enterprise_month/insured', data.data, data.success),
  costOrder: data =>
    _axios('enterprise_cost_month/costOrder', data.data, data.success),
  enterpriseMonthCost: data =>
    _axios('enterprise_month/cost', data.data, data.success),
  staffIncreaseDecrease: data =>
    _axios('staff_increase_decrease/confirm', data.data, data.success),
  exportBills: data =>
    _axios('ExportExecel/enterprise_expenses', data.data, data.success, true),
  // 分组导出
  exportBillsGroupsClass: data =>
    _axios('ExportExecel/enterprise_expenses_classify', data.data, data.success, true),
  // 全部导出
  exportBillsGroupsAll: data =>
    _axios('ExpensesAction/page_all', data.data, data.success, true),
  enterpriseCostUpdateOtherCosts: data =>
    _axios('enterprise_cost_month/update', data.data, data.success, true),
  groupsCostList: data =>
    _axios('enterprise_cost_month_department/list', data.data, data.success, false),
  groupsCostDetail: data =>
    _axios('enterprise_cost_month_department/detail', data.data, data.success, false),
  groupsCostOtherAdd: data =>
    _axios('enterprise_cost_month_other/add', data.data, data.success, true),
  groupsCostOtherEdit: data =>
    _axios('enterprise_cost_month_other/update', data.data, data.success, true),
  groupsCostOtherDetail: data =>
    _axios('enterprise_cost_month_other/detail', data.data, data.success, true),
  // 补缴记录删除
  paybackActionDelete: data =>
    _axios('paybackAction/delete', data.data, data.success, true),
  // 开票申请
  enterpriseCostMonthSubmit: data =>
    _axios('enterprise_cost_month/submit', data.data, data.success, true)
}

/** 日志模块
 * logDetail:日志详情
 * logList:日志列表
 * logList:日志删除
 * */
export let logModule = {
  logDetail: data => _axios('common_log/logDetail', data.data, data.success),
  logList: data => _axios('common_log/logList', data.data, data.success),
  logDel: data => _axios('common_log/logDelete', data.data, data.success)
}
/**
 * 流水模块
 * list: 列表
 * claimAdd:认领新增
 * claimDel:认领删除
 * */
export let flowModule = {
  list: data => _axios('enterprise_bank_statement_claim/list', data.data, data.success),
  claimAdd: data => _axios('enterprise_bank_statement_claim/add', data.data, data.success),
  claimDel: data => _axios('enterprise_bank_statement_claim/delete', data.data, data.success)
}
// 模板下载
export let downTemplateModule = data =>
  _axios('web_template/detail', data.data, data.success, true)
/**
 * 上传图片
 * option:{
 *  data:提交的参数
 *  success:成功回调方法
 * }
 * option.data{
 * catalog:保存目录
 * file:上传的文件
 * }
 * */
export let uploadImgAxios = option => {
  let { data, success: callback = function () {} } = option
  let _FormData = new FormData()
  let axiosUrl = ''
  // 赋值token等参数
  _FormData.append('token', store.state.userModule.token)
  _FormData.append('catalog', data.catalog)
  _FormData.append('file', data.file)
  // 如果设置了needData则是额外需要提交的数据 needData是对象
  if (data.needData) {
    for (let i in data.needData) {
      _FormData.append(i, data.needData[i])
    }
  }
  var _loading = ELEMENT.Loading.service({
    text: '文件上传中,请耐心等待……',
    target: document.querySelector('#main-el-main'),
    lock: true
  })
  // 如果是上传文件 http://sbadmin.gdychr.com/api_common是后台以前的上传方法，后续的使用mscf上传
  if (option.fileType == 'uploadFile') {
    axiosUrl =
    UPLOADURL + '/api_common/api_enterprise/file_upload'
  } else {
    // 否则都算上传图片
    axiosUrl =
    UPLOADURL + '/api_common/api_enterprise/image_upload'
  }
  // 如果是mscf的地址 加上mscfAjax参数  如:ImportExecel/employee_information
  if (option.mscfAjax) {
    axiosUrl = mscfUrl + option.mscfAjax
  }
  // 开始请求
  axios['post'](axiosUrl, _FormData)
    .then(function (response) {
      _loading.close()
      let [responseData = {}] = [response.data]
      let isSuccess = false // 是否成功上传

      // 如果是mscf的上传，使用code值判断，否则就是原本后台的接口使用status判断
      if (option.mscfAjax) {
        responseData.code == '0' ? (isSuccess = true) : ''
      } else {
        responseData.status == '000000' ? (isSuccess = true) : ''
      }
      // 如果是日志提醒，则设置内容
      var logTitle =
        responseData.data.title || responseData.message || '操作失败'
      // 显示错误详情信息
      var json_content = ''
      // 如果有错误详情信息，拿下来的时候是字符串，则转为数组并添加到标签
      if (responseData.data.json_content) {
        var json_content_arr = JSON.parse(responseData.data.json_content)
        for (let i = 0, n = json_content_arr.length; i < n; i++) {
          json_content = json_content + '<p>' + json_content_arr[i] + '</p>'
        }
      }
      // 如果上传成功
      if (isSuccess) {
        // 如果设置了显示日志
        if (option.isShowLog) {
          ELEMENT.MessageBox.alert(
            `
               <div class="">
                <p class="mb-5 col-6 bb-e pb-5">${logTitle}</p>
                 <div class="col-9">${json_content}</p></div>
                </div>
             `,
            responseData.message,
            {
              beforeClose: function (action, instance, done) {
                callback(responseData.data, responseData)
                done()
              },
              confirmButtonText: '关闭',
              dangerouslyUseHTMLString: true
            }
          )
          return false
        }
        callback(responseData.data, responseData)
      } else {
        // 如果设置了显示日志，则不显示错误信息
        if (option.isShowLog) {
          ELEMENT.MessageBox.alert(
            `
               <div class="">
                <p class="mb-5 col-6 bb-e pb-5">${logTitle}</p>
                 <div class="col-9">${json_content}</p></div>
                </div>
             `,
            responseData.message,
            {
              beforeClose: function (action, instance, done) {
                done()
              },
              confirmButtonText: '关闭',
              dangerouslyUseHTMLString: true
            }
          )
          return false
        }
        // 错误时执行提示信息
        ELEMENT.Message({
          message: responseData.message,
          type: 'error'
        })
      }
    })
    .catch(function (response) {})
}

/**
 * axios 请求方法
 *
 * @param url:请求地址
 * @param data:请求数据
 * @param type:请求方式
 * @param callback:回调方法
 * @param isLoding:是否开启loding
 * */
export const _axios = (
  url = '',
  data = {},
  callback = function () {},
  isLoding = false,
  type = 'POST'
) => {
  // 拼接接口地址
  url = mscfUrl + url
  // 提交方式转换成小写
  type = type.toLowerCase()
  // 获取token
  data.token = store.state.userModule.token

  // 如果url有传token值则拿url的token
  if (getQueryString('token')) {
    data.token = getQueryString('token')
    store.commit('SET_TOKEN', getQueryString('token')) // 设置token值
  }

  let _loading
  // 加载loding
  if (isLoding) {
    _loading = ELEMENT.Loading.service({
      target: document.querySelector('#main-el-main'),
      lock: true
    })
    setTimeout(function () {
      _loading.close()
    }, 6000)
  }
  // 开始请求
  axios[type](url, data)
    .then(function (response) {
      let [responseData = {}] = [response.data]
      // 判断uid等于0则是未登录，退出页面
      if (
        store.state.userModule.userMessage &&
        (!responseData.uid || responseData.uid == 0)
      ) {
        ELEMENT.Message({
          message: '未登录',
          type: 'error'
        })
        // store.commit("CLEAN_USER_INFO");
        // setTimeout(function () {
        //   window.location.href = rootUrl;
        // }, 1200);
        return false
      }
      // 如果有启动loading,则半秒后关闭
      if (_loading) {
        setTimeout(function () {
          _loading.close()
        }, 900)
      }
      if (responseData.code == 0) {
        // 成功
        // 设置token
        store.commit('SET_TOKEN', responseData.token)
        callback(responseData.data, responseData)
      } else {
        // 失败
        ELEMENT.Message({
          message: responseData.message,
          type: 'error'
        })
      }
    })
    .catch(function (response) {
      // 失败
    })
}

/**
 * 下载文件
 * @param filePath:文件路径
 * @param fileRoot:文件域名，默认使用baseImgPath常量
 * */
export let downFile = (filePath, fileRoot = baseImgPath) => {
  // 添加form方式下载
  var addForm = document.createElement('form')
  addForm.method = 'get'
  addForm.style = 'display:none;'
  addForm.action = fileRoot + filePath
  document.body.appendChild(addForm)
  addForm.submit()
}



// WEBPACK FOOTER //
// ./src/api/getData.js